import React, { useState } from "react";
import { ChangePassword, resetLogin } from "../../redux/authSlice";
import { useDispatch } from "react-redux";

function ChangesPassword() {
  const [current_password, setPassword] = useState("");
  const [new_password, setnewPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const validateForm = () => {
    if (new_password !== confirm_password) {
      return "Passwords do not match!";
    } else if (new_password.length < 6) {
      return "Password must be at least 6 characters long.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();

    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const response = await dispatch(
        ChangePassword({
          current_password,
          new_password,
          confirm_password,
        })
      );

      if (response?.error) {
        setError("Failed to update password. Please try again.");
      } else {
        dispatch(resetLogin());
        setError("");
        console.log("Password updated successfully.");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Current Password:</label>
          <input
            type="password"
            value={current_password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />
        </div>
        <div>
          <label>New Password:</label>
          <input
            type="password"
            value={new_password}
            onChange={(e) => setnewPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />
        </div>

        <div>
          <label>Confirm Password:</label>
          <input
            type="password"
            value={confirm_password}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter new password"
            required
          />
        </div>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <button type="submit">Change Password</button>
      </form>
    </>
  );
}

export default ChangesPassword;
